<template>
	<!--    <form action="https://gr8conf.us4.list-manage.com/subscribe/post?u=ac7af4c02d6cec67fe3198a63&amp;id=a2d8252601"-->
	<!--          method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" target="_blank" novalidate>-->
	<!--        <div class="row justify-content-md-center">-->
	<!--            <div class="col-md-3">-->

	<!--                <fg-input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL"-->
	<!--                          placeholder="Email address (mandatory)"/>-->
	<!--            </div>-->
	<!--            <div class="col-md-3">-->

	<!--                <fg-input type="text" value="" name="NAME" class="" id="mce-NAME" placeholder="Name (optional)"/>-->
	<!--            </div>-->
	<!--            <div class="col-md-1">-->

	<!--                <n-button round class="btn-info" type="submit" name="subscribe" id="mc-embedded-subscribe">Subscribe-->
	<!--                </n-button>-->
	<!--            </div>-->

	<!--        </div>-->
	<!--        <input type="hidden" id="gdpr_3013" name="gdpr[3013]" value="Y"-->
	<!--        <p class="small">We use Mailchimp as our marketing platform. By clicking Subscribe above, you acknowledge that-->
	<!--            your information will be transferred to Mailchimp for processing.-->
	<!--        </p>-->
	<!--        <p class="small">-->
	<!--            <a href="https://mailchimp.com/legal/" target="_blank">Learn more about Mailchimp's privacy-->
	<!--                practices here.</a></p>-->
	<!--        </div>-->
	<!--        <div id="mce-responses" class="clear">-->
	<!--            <div class="response" id="mce-error-response" style="display:none"></div>-->
	<!--            <div class="response" id="mce-success-response" style="display:none"></div>-->
	<!--        </div>-->
	<!--        &lt;!&ndash; real people should not fill this in and expect good things - do not remove this or risk form bot signups&ndash;&gt;-->
	<!--        <div style="position: absolute; left: -5000px;" aria-hidden="true">-->
	<!--            <input type="text" name="b_ac7af4c02d6cec67fe3198a63_a2d8252601" tabindex="-1" value=""></div>-->
	<!--        <div class="clear">-->
	<!--        </div>-->
	<!--        </div>-->
	<!--    </form>-->
	<div style="margin: auto; width: 50%">
		<vue-mailchimp-email-signup-form
				:element-id="'first-email-signup-form'"
				:url="'https://gr8conf.us4.list-manage.com/subscribe/post?u=ac7af4c02d6cec67fe3198a63&id=a2d8252601'"
				:title="'Subscribe to the Newsletter'"
				:subtitle="'We take privacy seriously and we will never spam or sell your information.'"
		/>
	</div>
</template>

<script>
import "vue-mailchimp-email-signup-form/dist/vue-mailchimp-email-signup-form.css"


export default {}

</script>
<style lang="scss">
@import "@/assets/scss/now-ui-kit/_variables.scss";

.subscribe-container {
	&__submit {
		background-color: $brand-primary;
		border-color: $primary-color-opacity;

		&:hover {
			background-color: darken($brand-primary, 10);
			border-color: darken($primary-color-opacity, 10);
		}
	}
}</style>
